import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

export const initReveal = (): void => {
  // Clear any existing ScrollTriggers to prevent duplicates during Vite HMR
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());

  // Check if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal grid cards inside Objectives section
  const section = document.getElementById('objetivos');
  if (section) {
    const cards = section.querySelectorAll('.reveal');
    if (cards.length > 0) {
      gsap.from(cards, {
        scrollTrigger: {
          trigger: section,
          start: 'top 85%', // Activates when the top of the section hits 85% of viewport height
          once: true,       // Run once and kill trigger to prevent state corruption during refreshes
        },
        opacity: 0,
        y: prefersReducedMotion ? 0 : 30,
        duration: prefersReducedMotion ? 0 : 0.8,
        stagger: prefersReducedMotion ? 0 : 0.15,
        ease: 'power2.out',
      });
    }
  }
};
